import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import { getColorByString } from "@msuite/utils/colors";
import type { WebfleetObject } from "@msuite/utils/types";
import { getWebfleetObjectTypeTranslationKey } from "@msuite/utils/vehicles";

/** Props Interface */
interface WebfleetObjectCardProps {
	resource: WebfleetObject;
}

export function WebfleetObjectCard({ resource }: WebfleetObjectCardProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="card v-stack gap-0 w-full">
			<p className="tabular-nums label">{resource.objectuid}</p>
			<div className="h-stack justify-between">
				<p>{resource.objectname}</p>
				{resource.objecttype && (
					<Tag
						variant="plain"
						color={getColorByString(resource.objectclassname)}
					>
						{t(getWebfleetObjectTypeTranslationKey(resource.objecttype))}
					</Tag>
				)}
			</div>
		</div>
	);
}
